import $ from 'jquery';
import Vue from 'vue';
import moment from 'moment';
import InputTypehead from './components/InputTypehead';
import InputDate from './components/InputDate';
import InputDateRange from './components/InputDateRange';

moment.locale('th');

const multiTripDefault = {
  'id' : '',
  'multi_trip_destination_from': '',
  'multi_trip_destination_to': '',
  'multi_trip_start_date': '',
}

const defaultFormData = {
  'pax_adult' : '',
  'pax_child' : '',
  'pax_baby' : '',
  'trip_type': 'round-trip',
  'destination_from': '',
  'destination_to': '',
  'more_info': '',
  'start_date': '',
  'end_date': '',
  'oneway_date' : '',
  'flight_booking_type': 'normal',
  'multi_trip': [
    {...multiTripDefault, id: +new Date},
    {...multiTripDefault, id: +new Date + 1},
  ]
}

if($('#vue-wow-form-flight-a').length){
  window.WowFormFlightA = new Vue({
    el: '#vue-wow-form-flight-a',
    components: { InputTypehead, InputDate, InputDateRange },
    data: {
      isInitAirportData: false,
      isSuccess: false,
      isSubmiting: false,
      airportData: [],
      formData: {...defaultFormData}
    },
    created: function () {
      this.loadAirportData();
    },
    methods: {
      loadAirportData: function() {
        this.airportData = new Promise((resolve, reject)=>{
          if (typeof(Storage) !== "undefined" && localStorage.txAirportData) {
            const data = JSON.parse(localStorage.txAirportData);
            this.isInitAirportData = true;
            resolve(data);
          } else {
            $.get(window.AJAX_URL, {
              dataType: 'json',
              _wpnonce: AJAX_NONCE,
              action: 'get_flight_airport'
            }, (data) => {
              const airportDataString = JSON.stringify(data.data);
              if( window.isLocalStorageNameSupported() !== false ){
                // localStorage.setItem('txAirportData', airportDataString);
              }
              this.isInitAirportData = true;
              resolve(data);
            });
          }
        });

      },
      addMultiTrip: function (){
        const newMultiTrip = {
          ...multiTripDefault,
          id: +new Date
        }
        this.formData.multi_trip = [
          ...this.formData.multi_trip,
          newMultiTrip
        ]
      },
      removeMultiTrip: function (targetIndex){
        this.formData.multi_trip = this.formData.multi_trip.filter( (item, index) => {
          return index !== targetIndex;
        } )
      },
      onFormDataUpdate: function (fieldName, fieldValue, multiTripIndex = null){
        if( typeof multiTripIndex !== 'undefined' && multiTripIndex !== null   ){
          this.formData.multi_trip[multiTripIndex][fieldName] = fieldValue || null;
        }else{
          this.formData[fieldName] = fieldValue || null;
        }
      },
      onSubmitForm: function(e){
        this.isSubmiting = true;
        this.isSuccess = false;
        $.ajax({
          type: "POST",
          url: window.AJAX_URL,
          dataType: 'json',
          data: {
            ...this.formData,
            action: 'booking_flight',
            _wpnonce: AJAX_NONCE
          },
          success: (data) => {
            this.isSuccess = true;
            this.resetForm();
          },
          error: (data) => {

          },
        })
        .always(() => {
          this.isSubmiting = false;
        });
      },
      resetForm: function(){
        this.formData = {
          ...defaultFormData, 
          'multi_trip': [
            {...multiTripDefault, id: +new Date},
            {...multiTripDefault, id: +new Date + 1},
          ]
        };
        $(this.$el).find('form')[0].reset();
      }
    },
    mounted: function () {
      if( this.$refs.flight_booking_type && this.$refs.flight_booking_type.value ){
        this.formData.flight_booking_type = this.$refs.flight_booking_type.value;
      }
    },
  });
}


